import React from "react";
import Preloader from "../helper/Preloader";
 import Breadcrumb from "../components/Breadcrumb";
 import BottomFooter from "../components/BottomFooter";
  import ScrollToTop from "react-scroll-to-top";
 import ProfileView from "../componentsAmazon/ProfileView";
import FooterOne from "../components/FooterOne";

const ProfileCustomerAmazon = () => {
  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#232F3F" />

      {/* Preloader */}
      <Preloader />
 
      {/* Breadcrumb */}
      <Breadcrumb title={"Profile"} />

      {/* ProfileView */}
      < ProfileView />
     {/* FooterOne */}
        <FooterOne />
      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default ProfileCustomerAmazon;
